export enum StorageEnum {
    NOTEDETAIL = 'note-detail',
    FORCE_RELOAD = 'force-reload',
    TABID = 'tabid',
    ACCESSTOKEN = 'auth-accessToken',
    WEBVIEW_TOKEN = 'webview.token',
    //scale
    SCALE = 'adjustedScale',
    // action
    DESTROY_UNSAVED = 'destroy_unsaved',
    // landing page
    LANDING_PAGE = 'landing',
    LOGOUT = 'logout',
    ALIASTRIGGER = 'alias-key-trigger',
    ALL_RECORDS = 'allRecords',
    MENU = 'menu',
    MENU_ITEM = 'menuItem',
    CONDITION = 'kids',
    WEB_NAV = 'web-navigate',
    HEADER = 'header',
    CORPPREFIX = 'corpPrefix'
};

export enum WebviewLandingHome {
    HOME_DAILY = 'home/daily',
    SCHEDULE_ADD = 'webview-schedule-select',
    MENU = 'webview-menu'
}

export enum WebviewTransist {
    SWITCHMENU = 'switch-menu',
    SWITCHADDSCHED = 'switch-add-schedule',
    SWITCHDETAIL = 'switch-detail',
    URL = 'switch-url',
    BLANK = 'switch-blank'
}
